import { config } from '@/config'

import { getLiff } from './init'

/**
 * LIFF のアクセストークン（liff.getAccessToken()）を取得する。
 *
 * サーバーはヘッダ x-utoniq-line-access-token を全 GraphQL 経路で任意として読み、
 * LINE サービスメッセージの token 発行・送信や退会時の連動アプリ権限取消に使う。
 * ヘッダが無い場合サーバー側は素通り（web 経由アクセスを許容）するため、
 * この関数は取得できないケースで絶対に throw せず null を返す。
 *
 * null になるケース:
 * - LINE ミニアプリビルド以外（config.platform に 'line' が無い）
 * - SSR / ビルド時（window 不在。initLiff が呼ばれず getLiff がタイムアウトするため先に弾く）
 * - LIFF 初期化失敗・未ログイン
 */
export const getLineAccessToken = async (): Promise<string | null> => {
  if (!config.platform.includes('line')) return null
  if (typeof window === 'undefined') return null
  try {
    const liff = await getLiff()
    return liff.getAccessToken()
  } catch {
    // 未初期化・init 失敗時は「LIFF 経由でないアクセス」と同等に扱う
    return null
  }
}
